exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-wrapper[data-v-5cd0afb4] {\n  position: relative;\n}\n.dropdown-menu[data-v-5cd0afb4] {\n  right: 0;\n  width: 550px;\n  margin-top: 16px;\n  background-color: #e9f1fb;\n  padding: 0;\n}\n.callbacks-department[data-v-5cd0afb4] {\n  min-width: 600px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.no-callbacks[data-v-5cd0afb4] {\n  padding: 22px;\n  text-align: center;\n  color: #085FCE;\n}\n.callbacks-list[data-v-5cd0afb4] {\n  padding-left: 0;\n  width: 100%;\n}", ""]);

// exports
